import type { ReactNode } from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useFeatureCardStyles } from './FeatureCard.styles';

export interface FeatureCardProps {
  title: string;
  description: string;
  icon?: ReactNode;
  className?: string;
  /**
   * Opt-in to the Figma-aligned 2026 visual style: floating white surface
   * with soft shadow and a tinted icon chip. Defaults to `false` so existing
   * usages render the legacy brand-tinted card unchanged.
   */
  figmaVariant?: boolean;
}

export const FeatureCard = ({
  title,
  description,
  icon,
  className,
  figmaVariant = false,
}: FeatureCardProps) => {
  const styles = useFeatureCardStyles();

  if (figmaVariant) {
    return (
      <div className={mergeClasses(styles.root, styles.rootFigma, className)}>
        <div className={mergeClasses(styles.iconBadge, styles.iconBadgeFigma)}>
          <span className={mergeClasses(styles.icon, styles.iconFigma)}>{icon}</span>
        </div>
        <div className={styles.figmaTextStack}>
          <span className={mergeClasses(styles.title, styles.titleFigma)}>{title}</span>
          <span className={mergeClasses(styles.description, styles.descriptionFigma)}>
            {description}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={mergeClasses(styles.root, className)}>
      <div className={styles.iconBadge}>
        <span className={styles.icon}>{icon}</span>
      </div>
      <span className={styles.title}>{title}</span>
      <span className={styles.description}>{description}</span>
    </div>
  );
};

FeatureCard.displayName = 'FeatureCard';
